import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e178f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "homepage" }
const _hoisted_2 = {
  class: "hero-section",
  ref: "homepage"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"cloud cloud-1\" data-v-3e178f1e></div><div class=\"cloud cloud-2\" data-v-3e178f1e></div><div class=\"cloud cloud-3\" data-v-3e178f1e></div><div class=\"cloud cloud-4\" data-v-3e178f1e></div><div class=\"cloud cloud-5\" data-v-3e178f1e></div><div class=\"cloud cloud-6\" data-v-3e178f1e></div><div class=\"cloud cloud-7\" data-v-3e178f1e></div><div class=\"cloud cloud-8\" data-v-3e178f1e></div>", 8)
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "hero-content text-center" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"laurel-wrapper\" data-v-3e178f1e><img src=\"/media/laurel-and-stars.webp\" alt=\"5 star rating\" class=\"laurel-stars mb-4\" data-v-3e178f1e><h2 class=\"laurel-title\" data-v-3e178f1e>#1 AI Tool for Getting Hired</h2></div><h1 class=\"hero-title\" data-v-3e178f1e>AI tools that get you <span class=\"highlight\" data-v-3e178f1e>hired</span></h1><p class=\"hero-subtitle\" data-v-3e178f1e> Track your applications, apply for jobs, prepare for interviews, and land your dream job quickly with JobBuddy&#39;s AI tools. </p>", 3)
const _hoisted_16 = { class: "cta-button" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right ms-2" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"dashboard-preview\" data-v-3e178f1e><div class=\"dashboard-card\" data-v-3e178f1e><img src=\"/media/Dashboard.webp\" alt=\"JobBuddy Dashboard\" class=\"dashboard-image\" data-v-3e178f1e></div></div><div class=\"featured-section\" data-v-3e178f1e><p class=\"featured-text\" data-v-3e178f1e>Featured on</p><div class=\"featured-logos-container\" data-v-3e178f1e><div class=\"featured-logos\" data-v-3e178f1e><div class=\"featured-logo\" data-v-3e178f1e><img src=\"/media/hackernews.svg\" alt=\"Hacker News\" class=\"logo hn-logo\" data-v-3e178f1e></div><div class=\"featured-logo\" data-v-3e178f1e><img src=\"/media/producthunt.svg\" alt=\"Product Hunt\" class=\"logo ph-logo\" data-v-3e178f1e></div><div class=\"featured-logo\" data-v-3e178f1e><svg class=\"logo x-logo\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" fill=\"none\" data-v-3e178f1e><path d=\"M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z\" fill=\"currentColor\" data-v-3e178f1e></path></svg></div><div class=\"featured-logo\" data-v-3e178f1e><img src=\"/media/reddit.svg\" alt=\"Reddit\" class=\"logo reddit-logo\" data-v-3e178f1e></div></div></div></div>", 2)
const _hoisted_20 = { class: "features-section" }
const _hoisted_21 = { class: "container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title text-center mb-2" }, [
  /*#__PURE__*/_createTextVNode(" AI tools for "),
  /*#__PURE__*/_createElementVNode("i", null, "every"),
  /*#__PURE__*/_createTextVNode(" step of your job search ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-subtitle text-center mb-3" }, " Create applications quicker, interview better, keep organized, and get hired ", -1))
const _hoisted_24 = { class: "features-nav-container" }
const _hoisted_25 = { class: "features-nav" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "feature-content-area"
}
const _hoisted_28 = { class: "feature-content-wrapper" }
const _hoisted_29 = { class: "feature-text" }
const _hoisted_30 = { class: "feature-header" }
const _hoisted_31 = { class: "feature-icon" }
const _hoisted_32 = { class: "feature-benefit" }
const _hoisted_33 = { class: "feature-description" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right ms-2" }, null, -1))
const _hoisted_35 = { class: "feature-image" }
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = { class: "pricing-section" }
const _hoisted_38 = { class: "container" }
const _hoisted_39 = { class: "final-cta-section py-5" }
const _hoisted_40 = { class: "container text-center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Ready to Land Your Dream Job?", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead mb-4" }, " Join thousands of professionals who've already found success with JobBuddy ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TestimonialsMini = _resolveComponent("TestimonialsMini")!
  const _component_Subscribe = _resolveComponent("Subscribe")!
  const _component_FAQs = _resolveComponent("FAQs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              class: "btn btn-white btn-lg",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.signup && $setup.signup(...args)))
            }, [
              _createTextVNode(" Get Hired "),
              _hoisted_17
            ])
          ]),
          _createVNode(_component_TestimonialsMini)
        ]),
        _hoisted_18
      ])
    ], 512),
    _createElementVNode("section", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.features, (feature, key) => {
              return (_openBlock(), _createElementBlock("button", {
                key: key,
                class: _normalizeClass(["feature-button", { active: $setup.activeFeature === key }]),
                onClick: ($event: any) => ($setup.activeFeature = key)
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(feature.icon)
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(feature.title), 1)
              ], 10, _hoisted_26))
            }), 128))
          ])
        ]),
        ($setup.activeFeature)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("i", {
                        class: _normalizeClass($setup.features[$setup.activeFeature].icon)
                      }, null, 2)
                    ]),
                    _createElementVNode("h3", null, _toDisplayString($setup.features[$setup.activeFeature].title), 1)
                  ]),
                  _createElementVNode("p", _hoisted_32, _toDisplayString($setup.features[$setup.activeFeature].benefit), 1),
                  _createElementVNode("ul", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.features[$setup.activeFeature].description, (point, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(point), 1))
                    }), 128))
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-white mt-4",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.signup && $setup.signup(...args)))
                  }, [
                    _createTextVNode(_toDisplayString($setup.features[$setup.activeFeature].cta || "Try Now") + " ", 1),
                    _hoisted_34
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("img", {
                    src: $setup.features[$setup.activeFeature].image,
                    alt: $setup.features[$setup.activeFeature].title,
                    class: "feature-image-single"
                  }, null, 8, _hoisted_36)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_Subscribe)
      ])
    ]),
    _createVNode(_component_FAQs),
    _createElementVNode("section", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _hoisted_42,
        _createElementVNode("button", {
          class: "btn btn-primary btn-lg",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.signup && $setup.signup(...args)))
        }, [
          _createTextVNode(" Get Started Now "),
          _hoisted_43
        ])
      ])
    ])
  ]))
}